import { useState } from 'react';

export const useFileLoader = (loading: boolean, error: boolean) => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  return { isLoading: loading || isLoading, isError: error || isError, setLoading, setError };
};
